import {
    IonButton,
    IonContent,
    IonImg,
    IonItem,
    IonLabel,
    IonList,
    IonPage,
    IonText,
    ToastOptions,
    useIonToast,
} from '@ionic/react';
import { Header } from '../components/Header';
import { IosHeader } from '../components/IosHeader';
import madper from '../assets/images/madper.png';
import { useAtomValue, useSetAtom } from 'jotai';
import { useState } from 'react';
import { usersAtom, loadingAtom, defaultToastOptions } from '../utils/Global';
import odoo from '../utils/odoo';
import { each } from 'lodash/fp';
import PasswordInput from '../components/PasswordInput';
import { toString } from 'lodash/fp';

const ResetPassword: React.FC = () => {
    const { mainUser } = useAtomValue(usersAtom);

    const [presentToast] = useIonToast();

    const setLoading = useSetAtom(loadingAtom);
    const [oldPassword, setOldPassword] = useState('');
    const [oldPasswordError, setOldPasswordError] = useState('');
    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [passwordConfirmError, setPasswordConfirmError] = useState('');

    const changePassword = async () => {
        if (!password) {
            setPasswordError('Le mot de passe est requis');
            return;
        }

        if (!oldPassword) {
            setOldPasswordError('Le mot de passe actuel est requis');
            return;
        }

        if (!passwordConfirm) {
            setPasswordConfirmError('La confirmation du mot de passe est requise');
            return;
        }

        if (password !== passwordConfirm) {
            presentToast({
                ...defaultToastOptions,
                message: 'Les mots de passe ne correspondent pas',
                color: 'danger',
                duration: 3000,
            });
            setPasswordError('Les mots de passe ne correspondent pas');
            setPasswordConfirmError('Les mots de passe ne correspondent pas');
            return;
        }

        if (mainUser) {
            setLoading(true);
            try {
                const res = await odoo.rpc('/web/session/change_password', {
                    fields: [
                        { name: 'old_pwd', value: oldPassword },
                        { name: 'new_password', value: password },
                        { name: 'confirm_pwd', value: passwordConfirm },
                    ],
                    context: { bypass_password_complexity_check: true },
                });
                if (res.data.result?.error) {
                    throw new Error(res.data.result?.error);
                }
                odoo.handleError(res);
                presentToast({
                    ...defaultToastOptions,
                    message: 'Mot de passe modifié avec succès',
                    color: 'success',
                    duration: 3000,
                });
                setOldPasswordError('');
                setPasswordError('');
                setPasswordConfirmError('');
            } catch (error: any) {
                if (error.message.includes('ancien mot de passe que vous avez fourni est incorrect')) {
                    setOldPasswordError('Ancien mot de passe incorrect');
                } else {
                    if (error.messages) {
                        each((errorToast: ToastOptions) => presentToast(errorToast), error.messages);
                    } else {
                        presentToast({
                            ...defaultToastOptions,
                            message: error.message,
                            color: 'danger',
                        });
                    }
                }
            }
            setLoading(false);
        }
    };

    return (
        <IonPage>
            <IosHeader title="Réinitialisation du mot de passe" />
            <IonContent className="content-log-d" fullscreen={true}>
                <Header title="Réinitialisation du mot de passe" />
                <IonImg className="mb-8 object-center w-40 mt-5 mx-auto" src={madper} alt="Madper Logo" />
                <IonList className="mx-8">
                    <IonItem className="mt-2" lines="inset">
                        <IonLabel className="font-bold" color="tertiary" position="floating">
                            <span className="text-xs">Mot de passe actuel</span>
                        </IonLabel>
                        <PasswordInput
                            value={oldPassword}
                            onchange={(e) => setOldPassword(toString(e.detail.value))}
                            autocomplete="current-password"
                            ariaLabel="Mot de passe actuel"
                        />
                    </IonItem>

                    {oldPasswordError && (
                        <IonText color="danger">
                            <p className="ion-padding-start mt-1 ml-2 text-xs">{oldPasswordError}</p>
                        </IonText>
                    )}
                    <IonItem className="mt-2" lines="inset">
                        <IonLabel className="font-bold" color="tertiary" position="floating">
                            <span className="text-xs">Nouveau mot de passe</span>
                        </IonLabel>
                        <PasswordInput
                            value={password}
                            onchange={(e) => setPassword(toString(e.detail.value))}
                            autocomplete="new-password"
                            ariaLabel="Nouveau mot de passe"
                            minlength={3}
                        />
                    </IonItem>

                    {passwordError && (
                        <IonText color="danger">
                            <p className="ion-padding-start mt-1 ml-2 text-xs">{passwordError}</p>
                        </IonText>
                    )}

                    <IonItem className="mt-2" lines="inset">
                        <IonLabel className="font-bold" color="tertiary" position="floating">
                            <span className="text-xs">Confirmer le mot de passe</span>
                        </IonLabel>
                        <PasswordInput
                            value={passwordConfirm}
                            onchange={(e) => setPasswordConfirm(toString(e.detail.value))}
                            autocomplete="new-password"
                            ariaLabel="Confirmer le mot de passe"
                        />
                    </IonItem>

                    {passwordConfirmError && (
                        <IonText color="danger">
                            <p className="ion-padding-start mt-1 ml-2 text-xs">{passwordConfirmError}</p>
                        </IonText>
                    )}
                </IonList>
                <div className="madper-button">
                    <IonButton shape="round" onClick={changePassword} expand="block" className="btn">
                        <button>Valider</button>
                    </IonButton>
                </div>
            </IonContent>
        </IonPage>
    );
};

export default ResetPassword;
